<template>
  <v-main ref="content" class="pt-0">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" class="mt-2">
            <v-tabs height="35" slider-size="3" :background-color="color(3)" @change="tabChanged" class="rounded-0" show-arrows v-model="selectedTab">
              <v-tab>{{ $t('toplst.tab.ttl.rt') }}</v-tab>
              <v-tab>{{ $t('toplst.tab.ttl.mem') }}</v-tab>
              <v-tab>{{ $t('toplst.tab.ttl.exe') }}</v-tab>
              <v-tab-item transition="false" reverse-transition="false">
                <v-card class="card-wrap">
                  <top-response-time :isFocus="rtFocus"></top-response-time>
                </v-card>
              </v-tab-item>
              <v-tab-item transition="false" reverse-transition="false">
                <v-card class="card-wrap">
                  <top-memory :isFocus="memFocus"></top-memory>
                </v-card>
              </v-tab-item>
              <v-tab-item transition="false" reverse-transition="false">
                <v-card class="card-wrap">
                  <top-execution :isFocus="exeFocus"></top-execution>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import TopResponseTime from '@/views/statistics/top-list/TopResponseTime.vue';
import TopMemory from '@/views/statistics/top-list/TopMemory.vue';
import TopExecution from './TopExecution.vue';

export default {
  components: {
    TopResponseTime,
    TopMemory,
    TopExecution,
  },
  data() {
    return {
      height: 0,
      lowerCardHeight: 0,
      rtFocus: true,
      memFocus: false,
      exeFocus: false,
      selectedTab: null,
    };
  },
  methods: {
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    tabChanged(index) {
      if (index == 1) {
        this.memFocus = true;
        this.rtFocus = this.exeFocus = false;
      } else if (index == 2) {
        this.exeFocus = true;
        this.rtFocus = this.memFocus = false;
      } else {
        this.rtFocus = true;
        this.exeFocus = this.memFocus = false;
      }
    },
  },
};
</script>
